import { render, staticRenderFns } from "./StudiesCompletedSlidebar.vue?vue&type=template&id=4a6ac22a"
import script from "./StudiesCompletedSlidebar.vue?vue&type=script&lang=js"
export * from "./StudiesCompletedSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports